var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { styled } from '@mui/system';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { colorPalette } from '../../colorPalette';
export const HtmlTooltip = styled((_a) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return React.createElement(Tooltip, Object.assign({}, props, { classes: { popper: className } }));
})(() => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: colorPalette.white,
        padding: '16px',
        width: 'auto',
        border: `1px solid ${colorPalette.gray200}`,
        boxShadow: '0 2px 5px rgba(74,74,74,.1)',
    },
    [`& .${tooltipClasses.arrow}`]: {
        color: colorPalette.white,
        backgroundColor: '#fff',
        border: 'solid #EBEBEB',
        borderWidth: '1px 0 0 1px',
        height: '16px',
        width: '16px',
        zIndex: 99,
        transform: 'rotate(45deg) !important',
        position: 'absolute',
        top: '-9px',
        left: '47.5% !important',
    },
}));
